module.exports = __webpack_public_path__ + "img/bg_avatar_female_66.cc8abe49.png";